module.exports = __webpack_public_path__ + "static/media/blockchainArt.069514b4.jpg";